<template>
    <svg viewBox="0 0 24 24" :width="size" :height="size">
        <!-- Boat on the left, pointing up -->
        <g transform="translate(6, 12) scale(0.6)">
            <path
                d="M0,-10 C3,-4 6,1 6,2 C6,5 4.5,8 4.5,8 L-4.5,8 C-4.5,8 -6,5 -6,2 C-6,1 -3,-4 0,-10 Z"
                fill="none"
                stroke="currentColor"
                stroke-width="2.3"
                stroke-linejoin="round"
            />
        </g>
        <!-- Mark on the right -->
        <circle cx="18" cy="12" r="3.5" fill="none" stroke="currentColor" stroke-width="1.4" />
        <!-- Full line in middle -->
        <line x1="9" y1="12" x2="13.5" y2="12" stroke="currentColor" stroke-width="1.4" />
    </svg>
</template>

<script setup lang="ts">
interface Props {
    size?: number | string
}

withDefaults(defineProps<Props>(), {
    size: 36,
})
</script>
